import { SUBAPPS } from "@perlab/registry";
import { useContextChain } from "./ContextChain";

// Honor manifest chrome mode — fullscreen/embed/auth apps hide the shell chrome. Was duplicated
// inline in SideNav.tsx and BottomTabBar.tsx (row 5.3 batch); consolidated here so a future new
// chrome mode, or any change to this rule, has one place to update instead of two that can drift.
export function useChromeVisible(): boolean {
  const { appId } = useContextChain();
  const app = appId ? SUBAPPS.find((a) => a.id === appId) : undefined;
  return !(app && app.chrome && app.chrome !== "default");
}
